"use client";

import type { ReactNode } from "react";
import { useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";
import { resolveSlotSport } from "@/lib/conditions/sport-aware-slot";

/**
 * Hides server-rendered sections for specific client-selected sports. The
 * conditions page is statically rendered with the primary sport, and ?sport=
 * switching happens client-side, so snow-framed bottom sections (season
 * snowfall, resort terrain, piste seasonality) would otherwise leak onto the
 * MTB view. Children stay in the server HTML for the default sport (SEO) and
 * are removed post-hydration when an excluded sport is active.
 */
export function HideForSports({
  sports,
  defaultSport,
  availableSports,
  children,
}: {
  sports: string[];
  defaultSport: string;
  availableSports: string[];
  children: ReactNode;
}) {
  const param = useShallowSearchParam("sport");
  const raw = param ?? defaultSport;
  const active = resolveSlotSport(raw, defaultSport, availableSports);
  if (sports.includes(active)) return null;
  return <>{children}</>;
}
